var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Mutation, State } from 'vuex-simple';
var ManagementPageModule = /** @class */ (function () {
    function ManagementPageModule(root) {
        this.root = root;
        this.readonly = false;
        this.validationRules = {};
        this.filterSidesheetVisible = false;
        this.crudSidesheetVisible = false;
        this.crudSidesheetLoading = false;
    }
    ManagementPageModule.prototype.setReadonly = function (value) {
        this.readonly = value;
    };
    ManagementPageModule.prototype.openCrudSidesheet = function (payload) {
        this.root.items.selectedItem = payload.item;
        this.crudSidesheetVisible = true;
        this.crudSidesheetMode = payload.mode;
    };
    ManagementPageModule.prototype.closeCrudSidesheet = function () {
        this.crudSidesheetVisible = false;
    };
    ManagementPageModule.prototype.openFilterSidesheet = function () {
        this.root.items.selectedItem = {};
        this.filterSidesheetVisible = true;
    };
    ManagementPageModule.prototype.closeFilterSidesheet = function () {
        this.filterSidesheetVisible = false;
    };
    ManagementPageModule.prototype.setValidationRules = function (value) {
        this.validationRules = value;
    };
    ManagementPageModule.prototype.setCrudSidesheetLoading = function (value) {
        this.crudSidesheetLoading = value;
    };
    __decorate([
        State(),
        __metadata("design:type", Boolean)
    ], ManagementPageModule.prototype, "readonly", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], ManagementPageModule.prototype, "validationRules", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], ManagementPageModule.prototype, "filterSidesheetVisible", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], ManagementPageModule.prototype, "crudSidesheetVisible", void 0);
    __decorate([
        State(),
        __metadata("design:type", String)
    ], ManagementPageModule.prototype, "crudSidesheetMode", void 0);
    __decorate([
        State(),
        __metadata("design:type", Object)
    ], ManagementPageModule.prototype, "crudSidesheetLoading", void 0);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "setReadonly", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "openCrudSidesheet", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "closeCrudSidesheet", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "openFilterSidesheet", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "closeFilterSidesheet", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "setValidationRules", null);
    __decorate([
        Mutation(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ManagementPageModule.prototype, "setCrudSidesheetLoading", null);
    return ManagementPageModule;
}());
export { ManagementPageModule };
